/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosDailyScheduleControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyUawChartCount(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/uaw/chart/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public deleteOldUawChartCount(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/uaw/chart/count/old',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyUserTransactionChart({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/transaction/user/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyPeakTps({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/transaction/peak',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyGasUnitPriceAvg({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/transaction/gas/unitprice/avg',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyGasConsumptionChart({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/transaction/gas/fee/sum',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyAllTransactionChart({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/transaction/all/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyMarketplaceChart({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/nft/marketplace/chart/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateDailyCollectionList(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/nft/collection/mview',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyCollectionFloorPriceChart({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/nft/collection/floor-price/chart/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyCollectionChart({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/nft/collection/chart/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTokenBridge({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/netflow/token-bridge',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public deleteTokenBridge(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/netflow/token-bridge/delete',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setCoinPriceHistorical(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/netflow/coin-price-historical',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public clearCache({
        period = 'H24',
    }: {
        period?: 'H24' | 'D7' | 'D30' | 'D90' | 'Y1' | 'YTD',
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/netflow/chart/clear-cache',
            query: {
                'period': period,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateFungibleAssetInfoMView(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/fa/mview/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setFungibleAssetHolderCount(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/fa/holder/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateFungibleCoinImageByAptoscan(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/fa-coin/image/bulk',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateVerifiedStatus(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/coin/verified/status',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateCoinInfoMView(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/coin/mview/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateCoinImageByPanoraExchange(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/coin/image/bulk',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setCoinHolderCount(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/coin/holder/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public coinAndFungiblePairMapping(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/coin-fa/pair/mapping',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateAddressLabel(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/address/label/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyAddressCreatedCountAvg({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/address/create/count',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setSignedAccountMonth({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/account/signed/month',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setSignedAccountDay({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/account/signed/day',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setCreatedAccount({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/schedule/daily/account/create',
            query: {
                'targetDate': targetDate,
            },
        });
    }

}
